import { Button, Modal, Stack } from "@salesapp/ui";

export function RevertToLeadModal({
  open,
  leadLabel,
  onCancel,
  onConfirm,
  saving = false,
}: {
  open: boolean;
  leadLabel?: string | null;
  onCancel: () => void;
  onConfirm: () => void;
  saving?: boolean;
}) {
  return (
    <Modal
      isOpen={open}
      onClose={onCancel}
      title="Move this deal back to a lead?"
      footer={
        <>
          <Button variant="secondary" onClick={onCancel} disabled={saving}>Cancel</Button>
          <Button onClick={onConfirm} disabled={saving}>
            {saving ? "Moving…" : "Move back to lead"}
          </Button>
        </>
      }
    >
      <Stack gap={3}>
        <p className="crm-help">
          Use this when a lead was converted by mistake. The opportunity goes to the recycle bin
          for 30 days. The source lead reopens on the Leads board so you can work it again.
        </p>
        {leadLabel ? <p>Source lead: {leadLabel}</p> : null}
      </Stack>
    </Modal>
  );
}
